<template>
  <div class="app container-md">
    <div class="NavHeader">
      <NavHeader  />
    </div>
    <div class="app_content" ref="app_content">
      <router-view></router-view>
      <right-menu ></right-menu>
      <NavFooter />
    </div>
  </div>
</template>

<script>
import NavHeader from "@/components/NavHeader.vue";
import NavFooter from "@/components/NavFooter.vue";
import rightMenu from "@/components/rightMenu.vue";

export default {
  components: {
    NavHeader,
    NavFooter,
    rightMenu,
  },
  created(){
    this.init()
    window.onbeforeprint = function (event){
      document.getElementsByClassName('page-right')[0].style.display = 'none'
    }
    window.onafterprint = function (event){
      document.getElementsByClassName('page-right')[0].style.display = 'block'
    }
  },
  methods:{
    init(){
      var link = document.querySelector("link[rel*='icon']") || document.createElement('link');
      link.type = 'image/x-icon';
      link.rel = 'shortcut icon';
      link.href = './favicon.ico'; // 图片放public目录
      document.getElementsByTagName('head')[0].appendChild(link);
    }
  },
  watch:{
    '$route':{
        immediate:true,
        handler(n){
            if(n.path=='/'){
                this.$router.push('/home')
            }
            sessionStorage.setItem('menu',n.path)
        }
    }
  },
};
</script>
<style scoped>
.app{
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  min-width: 1360px;
}
.NavHeader{
  height: 80px;
}
.app_content{
  height: calc(100% - 80px);
  overflow: hidden;
  overflow-y: auto;
  background-color: #F1F3F5;
}
/*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/
::-webkit-scrollbar {
  width: 7px;
  height: 7px;
  background-color: #f5f5f5;
}
/*定义滚动条轨道 内阴影+圆角*/
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  background-color: #f5f5f5;
}
/*定义滑块 内阴影+圆角*/
::-webkit-scrollbar-thumb {
  border-radius: 10px;
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
  background-color: #c8c8c8;
}
</style>